import { useCustomerApplicationsLatestSubmittedRetrieve } from "@boundless/bl-api-client/customer/services"
import { createFileRoute } from "@tanstack/react-router"
import { useStore } from "zustand/react"

import ApplicationsCard from "@/components/home/ApplicationsCard"
import CreateNewFundingRequestCard from "@/components/home/CreateNewFundingRequestCard"
import DebtTableCard from "@/components/home/DebtTableCard"
import LenderMatchCard from "@/components/home/LenderMatchCard"
import { store } from "@/lib/store"

export const Route = createFileRoute("/_dashboard/_customer/home")({
  component: HomeView,
})

export function HomeView() {
  const activeCompanyUuid = useStore(store, (state) => state.activeCompanyUuid)

  const { data: application } = useCustomerApplicationsLatestSubmittedRetrieve(
    activeCompanyUuid ?? "",
    {
      query: {
        enabled: !!activeCompanyUuid,
        staleTime: 0,
      },
    },
  )

  return (
    <div className="grid gap-6">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 [&>*]:min-w-0">
        <LenderMatchCard />
        <CreateNewFundingRequestCard disabled={!application?.isSubmitted} />
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 [&>*]:min-w-0">
        <ApplicationsCard disabled={!application?.isSubmitted} />
        <DebtTableCard disabled={!application?.isSubmitted} />
      </div>
    </div>
  )
}
